// toastHelper.ts
import { toast, ToastOptions } from "react-toastify";

type ToastType = "success" | "info" | "warning" | "error";

let currentToastId: string | null = null; // currentToastId tipini string | null olarak güncelledik

const CToast = (message: string, type: ToastType = "error"): void => {
  const options: ToastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClose: () => {
      currentToastId = null; // Toast kapanınca currentToastId'yi null yap
    },
  };
  // Kullanılabilir bir toast mesajı ID'si varsa güncelle, yoksa yeni bir toast göster
  if (currentToastId) {
    toast.update(currentToastId, {
      render: message,
      type: type,
      ...options,
    });
  } else {
    currentToastId = toast[type](message, options) as string; // toast[type] sonucunu string olarak type assertion yaptık
  }
};

export default CToast;
